export const HOST = "https://test.ttechr.com/";

export const EXTERNAL_LINKS = {
  twitter: "https://twitter.com/highscorega",
  instagram: "https://www.instagram.com/highscorega/",
  discord: "https://discord.gg/tkP6mWkMt7",
  blog: "https://hsga.beehiiv.com/",
};

export const IMGIX_HOST = "https://hswm.imgix.net/";
